import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FundAndAction } from "../shared/modal-fund-update/modal-fund-update.component";

@Injectable({
  providedIn: 'root',
})
export class FundsEntitiesPageService {
  _showFundUpdateModal: BehaviorSubject<boolean> = new BehaviorSubject(false);
  _showModalLegalFundInfoCrud: BehaviorSubject<boolean> = new BehaviorSubject(false);
  _isCreateManagementCompany: BehaviorSubject<boolean> = new BehaviorSubject(false);
  _fundModalAction: BehaviorSubject<FundAndAction> = new BehaviorSubject(undefined);

  get showFundUpdateModal(): BehaviorSubject<boolean> {
    return this._showFundUpdateModal;
  }

  setShowFundUpdateModal(value : boolean): void {
    this._showFundUpdateModal.next(value);
  }

  get showModalLegalFundInfoCrud(): BehaviorSubject<boolean> {
    return this._showModalLegalFundInfoCrud;
  }

  setShowModalLegalFundInfo(value : boolean): void {
    this._showModalLegalFundInfoCrud.next(value);
  }

  get isCreateManagementCompany(): BehaviorSubject<boolean> {
    return this._isCreateManagementCompany;
  }

  setIsCreateManagementCompany(value : boolean): void {
    this._isCreateManagementCompany.next(value);
  }

  get fundModalAction(): BehaviorSubject<FundAndAction> {
    return this._fundModalAction;
  }

  setFundModalAction(value : FundAndAction): void {
    this._fundModalAction.next(value);
  }
}
